module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/teachers/paula-czyz-1decc4dacdfc70f3aa84dab8131ba493.png";